module.exports = __webpack_public_path__ + "icons/original/small/small-e2.2a6f0dc9158e2248beb5da27abf58387.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-e2.png
// module id = uLm8
// module chunks = app